import i18n from '../utils/i18n';
import Invalidation from '../pages/Invalidation';
import ProductNew from '../pages/ProductNew';
import { IconEnum } from '../ui/Icon';
import Product from '../pages/Product';
import BrandAll from '../pages/BrandAll';
import CategoryAll from '../pages/CategoryAll';
import ProductAll from '../pages/ProductAll';
import Homepage from '../pages/Homepage';
import PriceAttr from '../pages/PriceAttr';
import Category from '../pages/Category';
import DeliveryAll from '../pages/DeliveryAll';
import Delivery from '../pages/Delivery';
import DeliveryNew from '../pages/DeliveryNew';
import CategoryNew from '../pages/CategoryNew';
import CategoryFilters from '../pages/CategoryFilters';

interface IPath {
    path: string;
    icon?: IconEnum;
    label?: string;
    mainMenu?: boolean;
    homepage?: boolean;
    element: () => any;
}

export const paths = {
    product: '/product/',
    productAll: '/product/all',
    productNew: '/product/new',
    priceAttrAll: '/price-attr/all',
    brand: '/brand/',
    brandAll: '/brand/all',
    brandNew: '/brand/new',
    categoryAll: '/category/all',
    category: '/category/',
    categoryNew: '/category/new',
    categoryFilters: '/category-filters',
    deliveryAll: '/delivery',
    deliveryNew: '/delivery/new',
    delivery: '/delivery/',
    invalidation: '/invalidation',
    login: '/login',
};

export const pathsApi = {
    priceAttrAll: '/price-attr',
    priceAttrSave: '/price-attr/save',
    priceAttrSortSave: '/price-attr/sort-save',
    productAll: '/product',
    product: '/product/',
    uploadFile: '/files/upload',
    deleteFile: '/files/delete',
    config: '/config',
    productSave: '/product/save',
    productByCategory: '/product/by-category',
    productSort: '/product/sort-save',
    brandAll: '/brand',
    categoryAll: '/category',
    category: '/category/',
    categorySort: '/category/sort-save',
    categorySave: '/category/save',
    categoryChildren: '/category/children',
    deliveryAll: '/delivery',
    delivery: '/delivery/',
    deliverySort: '/delivery/sort-save',
    deliverySave: '/delivery/save',
    invalidateAll: '/invalidation',
    cleanCache: '/invalidation/clean',
    cleanCacheAll: '/invalidation/force_clean_all',
    categoryFilters: '/category/filters',
    categoryFiltersSaveItem: '/category-filters/save',
    categoryFiltersSaveGroup: '/category-filters/save-group',
};

export const routes: Array<IPath> = [
    {
        path: '/',
        element: Homepage,
    },
    {
        path: paths.productNew,
        label: i18n.menu.productNew,
        icon: IconEnum.DOC_NEW,
        homepage: true,
        element: ProductNew,
    },
    {
        path: paths.productAll,
        label: i18n.menu.products,
        mainMenu: true,
        homepage: true,
        icon: IconEnum.DOCS,
        element: ProductAll,
    },
    {
        path: paths.priceAttrAll,
        label: i18n.menu.priceAttr,
        mainMenu: true,
        homepage: true,
        icon: IconEnum.ATTR,
        element: PriceAttr,
    },
    {
        path: paths.product + ':id',
        element: Product,
    },
    {
        path: paths.product + ':id/edit',
        element: ProductNew,
    },
    {
        path: paths.brandAll,
        label: i18n.menu.brand,
        mainMenu: true,
        homepage: true,
        icon: IconEnum.BRAND,
        element: BrandAll,
    },
    {
        path: paths.categoryAll,
        label: i18n.menu.category,
        mainMenu: true,
        homepage: true,
        icon: IconEnum.CATALOG,
        element: CategoryAll,
    },
    {
        path: paths.category + ':id/edit',
        element: CategoryNew,
    },
    {
        path: paths.categoryNew,
        element: CategoryNew,
    },
    {
        path: paths.category + ':id',
        element: Category,
    },
    {
        path: paths.categoryFilters,
        label: i18n.menu.categoryFilters,
        homepage: true,
        icon: IconEnum.FILTER,
        element: CategoryFilters,
    },
    {
        path: paths.deliveryAll,
        label: i18n.menu.delivery,
        mainMenu: true,
        homepage: true,
        icon: IconEnum.DELIVERY,
        element: DeliveryAll,
    },
    {
        path: paths.delivery + ':id',
        element: Delivery,
    },
    {
        path: paths.deliveryNew,
        element: DeliveryNew,
    },
    {
        path: paths.delivery + ':id/edit',
        element: DeliveryNew,
    },
    {
        path: paths.invalidation,
        label: i18n.menu.cacheClean,
        mainMenu: true,
        homepage: true,
        icon: IconEnum.DATABASE,
        element: Invalidation,
    },
];
